import { useQuery } from '@tanstack/react-query';
import { contractApi } from '@/features/contracts/api/contractApi';

/**
 * Hook pour récupérer le détail d'un contrat
 */
export const useContract = (id: number | undefined) => {
  return useQuery({
    queryKey: ['contract', id],
    queryFn: () => contractApi.getContract(id!),
    enabled: !!id,
    staleTime: 30000,
  });
};
